import { Bike, CarFront, ChevronRight, MapPin, Navigation, ShieldCheck } from 'lucide-react';

export function PhonePreview() {
  return (
    <div className="phone-stage" aria-label="Illustrative Sawwari mobile booking interface">
      <div className="route-chip route-chip--top"><ShieldCheck size={15} /> Secure request</div>
      <div className="route-chip route-chip--bottom"><span /> Pakistan-wide</div>
      <div className="phone">
        <div className="phone__speaker" />
        <div className="phone__screen">
          <div className="mini-header">
            <div>
              <small>Good afternoon</small>
              <strong>Where are you going?</strong>
            </div>
            <span>ZA</span>
          </div>
          <div className="mini-map">
            <div className="map-road map-road--one" />
            <div className="map-road map-road--two" />
            <div className="map-road map-road--three" />
            <div className="map-pin map-pin--start"><MapPin size={15} /></div>
            <div className="map-pin map-pin--end"><Navigation size={14} /></div>
            <div className="map-label map-label--one">Pickup area</div>
            <div className="map-label map-label--two">Destination</div>
          </div>
          <div className="mini-panel">
            <div className="mini-search"><span /><p>Choose destination</p><ChevronRight size={16} /></div>
            <p className="mini-kicker">Choose a service</p>
            <div className="mini-options">
              <button type="button" className="is-active"><CarFront /><span>Ride</span></button>
              <button type="button"><Bike /><span>Bike</span></button>
              <button type="button"><span className="mini-box">□</span><span>Courier</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
